import closeIcon from '_assets/img/icons/svg/cross-icon.svg';
import Image from '_atoms/Image';
import { FC } from 'react';

import './CloseIcon.scss';

type PropsShape = {
    onClick?: () => void;
    src?: string;
    size?: 'small' | 'medium'; // default is medium. Small is 16px, medium is 24px.
};

const CloseIcon: FC<PropsShape> = ({
    onClick,
    src,
    size = 'medium',
}): React.JSX.Element => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (
        <div className={`close-icon ${size}`} onClick={handleClick}>
            <Image alt="Close" src={src ?? closeIcon} />
        </div>
    );
};

export default CloseIcon;
